export default __webpack_public_path__ + "static/spidey-boss-8a0c1e368f39eef7044230f607f2bda6.png";